import { useState } from 'react';

import Address from '../../models/Address';

import type AddressDetails from '../../models/AddressDetails';

export const useGetAddress = () => {
  const [data, setData] = useState(new Address());

  const setAddress = (newAddressToSet: Address) => {
    setData(newAddressToSet);
  };

  const setAddressDetails = (newAddressDetails: ReturnType<typeof AddressDetails>) => {
    const prevSearchState = structuredClone(data);

    setData({ ...prevSearchState, ...newAddressDetails } as unknown as Address);
  };

  return { data, setAddress, setAddressDetails };
};
